export default __webpack_public_path__ + "static/media/defaultAvatar-business-card.a9e7b310.svg";